import { AlertTriangle } from "lucide-react";
import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "../ui/button";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error("SalesPilot render failure", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="grid min-h-dvh place-items-center bg-background px-6 text-foreground">
        <section className="max-w-sm text-center">
          <AlertTriangle className="mx-auto size-8 text-amber-600" aria-hidden="true" />
          <h1 className="mt-4 text-xl font-semibold">页面暂时无法显示</h1>
          <p className="mt-2 text-sm leading-6 text-muted-foreground">
            你的数据没有丢失。请重新载入；如果问题持续出现，可返回登录页重新进入。
          </p>
          <Button className="mt-6 w-full" onClick={() => window.location.reload()}>
            重新载入
          </Button>
        </section>
      </main>
    );
  }
}
